<ng-container *ngIf="!send; else good">
    <div class="poll-block">
        <ng-container *ngIf="poll; else defaultPoll" >
            <div class="poll-title" >
                {{poll.name?poll.name:'Новая форма'}}
            </div>
            <div class="poll-description">
                {{poll.description?poll.description:'Описание'}}
            </div>
        </ng-container>
        <ng-template #defaultPoll>
            <div class="poll-title" >
                Новая форма
            </div>
            <div class="poll-description">
                Описание
            </div>
        </ng-template>
    </div>
    
    <ng-container *ngIf="pollSchema !== null" >
        <sf-form 
        [schema]="pollSchema" 
        (onChange)="this.pollModel=$event.value">
        <!-- attr.schema - Schema опросника
        (onChange) - изменение значении модели (ответа опросника) при событие onChange -->
        </sf-form>
    </ng-container> 


    <!-- <div *ngIf="pollModel">
        {{pollModel | json}}</div> -->
    <button class="send" (click)="saveAnswer(pollModel)">Отправить</button>
</ng-container>
<ng-template #good>
    <div class="poll-block send">
        <ng-container *ngIf="poll; else defaultAnswer" >
            <div class="poll-title" >
                {{poll.name?poll.name:'Заголовок формы'}}
            </div>
        </ng-container>
        <ng-template #defaultAnswer>
            <div class="poll-title" >
                Заголовок формы
            </div>
        </ng-template>
        <div class="poll-description">
            Ответ записан
        </div>
    </div>
</ng-template>

